import api from "./axiosInstance";

import { Album } from "../models/Album";
import { AlbumDTO } from "../models/DTOs/AlbumDTO";
import { FotoDTO } from "../models/DTOs/FotoDTO";

const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const listAlbums = async (): Promise<AlbumDTO[]> => {
  const res = await api.get(`${process.env.REACT_APP_API_URL}/album/list`);
  return res.data;
};

// Lista imagens por prefixo
export const readWithFotos = async (albumId: string): Promise<AlbumDTO> => {
  const res = await api.get(
    `${process.env.REACT_APP_API_URL}/album/read-with-fotos?id=${albumId}`
  );
  return res.data;
};

// Lista imagens por prefixo
export const listImagesByAlbum = async (albumId: string): Promise<FotoDTO[]> => {
  const res = await api.get(
    `${process.env.REACT_APP_API_URL}/album/list-imagens-by-album?albumId=${albumId}`
  );
  return res.data;
};

export const createAlbum = async (
  nome: string,
  trancadoAte: string | null,
): Promise<Album> => {
  const res = await api.post(
    `${process.env.REACT_APP_API_URL}/album/create`,
    { nome, trancadoAte},
    { headers: { "Content-Type": "application/json", ...getAuthHeader() } }
  );
  return res.data.album;
};

export const updateAlbum = async (
  id: string,
  nome?: string,
  capaArquivoNome?: string,
  trancadaAte?: string | null,
): Promise<Album> => {
  const res = await api.put(
    `${process.env.REACT_APP_API_URL}/album/update`,
    { id, nome, capaArquivoNome, trancadaAte },
    { headers: { "Content-Type": "application/json", ...getAuthHeader() } }
  );
  return res.data.album;
};

export const deleteAlbum = async (id: string): Promise<{ message: string }> => {
  const res = await api.delete(
    `${process.env.REACT_APP_API_URL}/album/delete?id=${id}`,
    { headers: getAuthHeader() }
  );
  return res.data;
};

export const uploadAlbumImages = async (
  files: FileList,
  prefix: string
): Promise<string[]> => {
  const formData = new FormData();
  formData.append("prefix", prefix);

  for (let i = 0; i < files.length; i++) {
    formData.append("files", files[i]);
  }

  const res = await api.post<{ uploadedUrls: string[] }>(
    `${process.env.REACT_APP_API_URL}/album/adicionar-imagem`,
    formData,
    { headers: { ...getAuthHeader() } }
  );

  return res.data.uploadedUrls;
};

export const updateAlbumCoverImage = async (
  id: string,
  fotoId: string
): Promise<Album> => {
  const res = await api.post(
    `${process.env.REACT_APP_API_URL}/album/adicionar-capa`,
    { id, fotoId },
    { headers: { "Content-Type": "application/json", ...getAuthHeader() } }
  );
  return res.data.album;
};

export const uploadPhoto = async (formData: FormData) => {
  return api.post(
    `${process.env.REACT_APP_API_URL}/album/adicionar-foto`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        ...getAuthHeader()
      }
    }
  );
};